import { MutationOptions, useMutation, useQueryClient } from "react-query";
import { APIError, APIResponse, postFormData } from "../api";
import { API_URL } from "../api";

function useIDUpload<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const client = useQueryClient();
  const {
    isLoading: uploadingID,
    isError: isIDUploadError,
    error: idUploadError,
    mutate: uploadID,
  } = useMutation(
    (variables: Record<any, any>) => {
      const url = API_URL + "/account/user/account/upload-compliance-image";

      const formData = new FormData();
      formData.append("compliance_type_1", variables.compliance_type_1);
      formData.append(
        "compliance_image_1",
        variables.compliance_image_1.file,
        variables.compliance_image_1.name
      ); // Replace with your actual file data if you need to upload an image

      const headers = {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      };

      const options = {
        headers: headers,
      };

      return postFormData(url, formData, options);
    },
    {
      ...options,
      onSettled() {
        client.invalidateQueries("profile");
      },
    }
  );

  return {
    uploadID,
    isIDUploadError,
    idUploadError,
    uploadingID,
  };
}

export default useIDUpload;
